import {EditableFieldModel} from "@white-label/components/page-builder/models/edit-component.model";
import {FieldType} from "@white-label/components/page-builder/models/model.map";
import {OneReview} from "@white-label/components/page-builder/models/reviews.model";

export class SponsorsModel {

    sponsors = new EditableFieldModel('sponsors', FieldType.array, [
        new SponsorModel(),
        new SponsorModel(),
        new SponsorModel(),
        new SponsorModel(),
        new SponsorModel()
    ], SponsorModel)

    fieldsMap = [this.sponsors];
    constructor(data?:{sponsors?: any}) {
        if(data?.sponsors){
            this.sponsors.value = []
            for(let sponsor of data?.sponsors.value){
                this.sponsors.value.push(new SponsorModel(sponsor));
            }
        }
    }
}

export class SponsorModel {
    avatarUrl = new EditableFieldModel('avatarUrl', FieldType.image, '/assets/image/logo/cola.svg');
    title = new EditableFieldModel('title', FieldType.text, 'Coca cola');
    linkUrl = new EditableFieldModel('linkUrl', FieldType.link, 'https://coca-cola.com');
    fieldsMap = [this.avatarUrl, this.title, this.linkUrl];

    constructor(data?: {avatarUrl?: any, title?: any, linkUrl?: any}) {
        if(data?.avatarUrl){
            this.avatarUrl.value = data.avatarUrl.value;
        }
        if(data?.title){
            this.title.value = data.title.value;
        }
        if(data?.linkUrl){
            this.linkUrl.value = data.linkUrl.value;
        }
    }
}